const accordion = document.querySelector('.js_faq');
if(accordion != null){
  const items = accordion.querySelectorAll('.js_faq_content_lists_list');
  const questions = accordion.querySelectorAll('.js_faq_content_lists_list_question');

  function toggleAccordion() {
    const thisItem = this.parentNode;
    
    items.forEach(item => {
      if (thisItem == item ) {
      
        thisItem.classList.toggle('open');
        return;
      } 
      
      item.classList.remove('open');
    });
  }

  questions.forEach(question => question.addEventListener('click', toggleAccordion));
}